module.exports = __webpack_public_path__ + "static/media/hubspot.68dd9dda.png";